import React, { FC, Fragment } from 'react';
import { GQL } from '@gin-betting/core';

import { countryReg } from 'app-constants';
import { FlagIcon } from 'components';
import { getTournamentCountryCode } from '../../../utils';

interface InputProps {
    item: GQL.CategorizerItem;
    withFlag?: boolean;
}

const TournamentTitle: FC<InputProps> = ({ item, withFlag = true }) => (
    <span>
        {item.name.replace(countryReg, '')}
        {withFlag && (
            <Fragment>
                &nbsp;
                <FlagIcon countryCode={getTournamentCountryCode(item, true)} />
            </Fragment>
        )}
    </span>
);

export default TournamentTitle;
